module.exports = __webpack_public_path__ + "static/media/search.7ee90a53.png";